import { useMemo, useRef, useState, useEffect } from "react";
import Card from "../../../../componentes/contenedores/Card";
import Page from "../../../../componentes/plantilla/Page";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import TablaSelectLotes from "./TablaSelectLote";

const HomeSelectLotes = () => {
    const { listaProductos, setListaProductos, ActualizarLista, listaTiposProductos } = useContextEmpleado();
    const { token } = useContextUsuario();
    const [filtroEstadoLote, setFiltroEstadoLote] = useState("Disponible");
    const [filtroCategoria, setFiltroCategoria] = useState('');

    const refTabla = useRef(null);
    const tablaSelectLotesRef = useRef(null);

    const datos = {
        titulo: {
            titulo: "Seleccion de lote a inventario",
            url: "/app/admin/lotes/asignar",
            tituloUrl: "lotes",
            nombreUrl: "seleccion",
        },
    };

    const estadosLote = [
        { value: "Disponible", label: "Disponible" },
        { value: "Agotado", label: "Agotado" },
        { value: "Todos", label: "Todos" },
    ];

    const productosFiltrados = useMemo(() => {
        const productosPorCategoria = filtroCategoria === ''
            ? listaProductos
            : listaProductos.filter(producto => {
                const productoIdString = producto.productoTipoId ? String(producto.productoTipoId) : '';
                return productoIdString === filtroCategoria;
            });

        const resultadoFinal = productosPorCategoria.map(producto => {
            const lotesFiltrados = filtroEstadoLote === "Todos"
                ? producto.lotes
                : producto.lotes?.filter(lote => lote.estado === filtroEstadoLote);

            return {
                ...producto,
                lotes: lotesFiltrados,
            };
        })
            //.filter(producto => producto.lotes && producto.lotes.length > 0);

        return resultadoFinal;

    }, [listaProductos, filtroEstadoLote, filtroCategoria]);

    useEffect(() => {
        const observer = new ResizeObserver(entries => {
            if (entries[0].contentBoxSize) {
                if (tablaSelectLotesRef.current && typeof tablaSelectLotesRef.current.adjustColumns === 'function') {
                    tablaSelectLotesRef.current.adjustColumns();
                }
            }
        });

        if (refTabla.current) {
            observer.observe(refTabla.current);
        }

        return () => {
            if (refTabla.current) {
                observer.unobserve(refTabla.current);
            }
        };
    }, []);

    return (
        <Page datos={datos}>
            <div ref={refTabla}>
                <Card titulo="Asignar lotes">
                    <div className="row mb-3">
                        <div className="col-12 col-md-6 col-lg-3">
                            <label htmlFor="filtroEstadoLote" className="form-label">Filtrar por estado:</label>
                            <select
                                id="filtroEstadoLote"
                                className="form-control"
                                value={filtroEstadoLote}
                                onChange={(e) => setFiltroEstadoLote(e.target.value)}
                            >
                                {estadosLote.map((estado) => (
                                    <option key={estado.value} value={estado.value}>
                                        {estado.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4">
                            <label htmlFor="filtroCategoria" className="form-label">Filtrar por categoría:</label>
                            <select
                                id="filtroCategoria"
                                className="form-control"
                                value={filtroCategoria}
                                onChange={(e) => setFiltroCategoria(e.target.value)}
                            >
                                <option value="">Todas las categorías</option>
                                {listaTiposProductos?.map((tipo) => (
                                    <option key={tipo.id} value={String(tipo.id)}>
                                        {tipo.nombre}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <TablaSelectLotes
                        ref={tablaSelectLotesRef}
                        datos={productosFiltrados}
                        filtroEstadoLote={filtroEstadoLote}
                    />
                </Card>
            </div>
        </Page>
    );
};

export default HomeSelectLotes;